module.exports = __webpack_public_path__ + "img/Hos_ertong.d47e4510.png";